import { Widget } from '../../core/types/Widget';
import { WidgetType } from '../../core/types/WidgetType';
import { enumFromStringValue } from '../../utils/enumFromStringValue';
import getWidget from '../../utils/getWidget';

/**
 * For backwards compatibility ensure we use the display type to get the widget config
 * This is to handle old placeholders which request a display type which is now a widget
 * type & could have support for different product types
 */
export const getWidgetFromDisplayTypeOrWidgetType = (
  displayType?: string,
  widgetType?: string,
): Widget => {
  const displayTypeWidgetId = enumFromStringValue(WidgetType, displayType);
  if (displayTypeWidgetId) {
    return getWidget(displayTypeWidgetId);
  }

  const widgetId = enumFromStringValue(WidgetType, widgetType);
  if (!widgetId) {
    throw new Error(`Invalid widget type: ${widgetType}`);
  }
  return getWidget(widgetId);
};
